var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { INDOOR_MAP } from "../../store/common/constants";
import { setMapsOnOverview } from "../../store/reducers/appSlice";
import { setVenues } from "../../store/reducers/venuesSlice";
import { VenueDetailsCard } from "./components";
import { Pagination, } from "../../generic-components/Pagination";
import Loader from "../../components/loader";
import { getDraftStatus, getButtonText, getMapData, getMapState, } from "./helper";
import { HEADER_TABS, HeaderTabKeys } from "../../store/common/constants";
import "./venuesList.scss";
var VenuesList = function (props) {
    var data = props.data, handleVenueListUpdated = props.handleVenueListUpdated;
    var dispatch = useDispatch();
    var token = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.user.token; });
    var selectedTab = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.selectedTab; });
    var mapsOnOverview = useSelector(function (state) { return state.app.mapsOnOverview; });
    var user = useSelector(function (state) { return state.user.info; });
    var env = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.environment; });
    var venuesListArray = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.initialVenuesList; });
    var _a = useState(1), pageNumber = _a[0], setPageNumber = _a[1];
    var _b = useState(INDOOR_MAP.MAP_PER_PAGE), mapsPerPage = _b[0], setMapsPerPage = _b[1];
    var _c = useState(data.slice(0, mapsPerPage - 1)), venueState = _c[0], setVenueState = _c[1];
    var handlePageChange = function (e) {
        var _a = e.detail, page = _a.page, itemsPerPage = _a.itemsPerPage;
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setPageNumber(page);
        // only update mapsPerPage when user updates page dropdown
        if (itemsPerPage !== mapsPerPage) {
            setMapsPerPage(itemsPerPage);
        }
    };
    var getCurrentMapOnPage = function (venue) {
        var startIndex = (pageNumber - 1) * mapsPerPage;
        var endIndex = startIndex + mapsPerPage;
        return venue.length > 0 ? venue.slice(startIndex, endIndex) : [];
    };
    var updateDraftMaps = function (draftMapObj) { return __awaiter(void 0, void 0, void 0, function () {
        var newVenueState, draftMapIds, resp_1, draftStateResponse_1, currentMapOnThePage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newVenueState = data;
                    draftMapIds = Object.keys(draftMapObj);
                    if (!draftMapIds.length) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.allSettled(Object.values(draftMapObj))];
                case 1:
                    resp_1 = (_a.sent());
                    draftStateResponse_1 = { draftState: "" };
                    newVenueState = [];
                    data === null || data === void 0 ? void 0 : data.forEach(function (v) {
                        var _a, _b;
                        if (draftMapIds.indexOf(v.id) > -1) {
                            if (resp_1[draftMapIds.indexOf(v.id)].status === "fulfilled") {
                                draftStateResponse_1 = (_b = (_a = resp_1[draftMapIds.indexOf(v.id)]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.data;
                            }
                            newVenueState.push(__assign(__assign({}, v), { draftStatus: getDraftStatus(draftStateResponse_1.draftState), buttonText: getButtonText(draftStateResponse_1.draftState), state: getMapState(draftStateResponse_1.draftState, v.modified, v.created) }));
                        }
                        else {
                            newVenueState.push(v);
                        }
                    });
                    return [3 /*break*/, 3];
                case 2:
                    currentMapOnThePage = newVenueState === null || newVenueState === void 0 ? void 0 : newVenueState.slice((pageNumber - 1) * mapsPerPage, pageNumber * mapsPerPage);
                    setVenueState(currentMapOnThePage);
                    _a.label = 3;
                case 3:
                    // this is to send signal if all the draft has updated status
                    handleVenueListUpdated(true);
                    //dispatch(setVenues(newVenueState));
                    updateList(newVenueState);
                    return [2 /*return*/];
            }
        });
    }); };
    var updateList = function (newVenueState) {
        if (selectedTab === HEADER_TABS[HeaderTabKeys.OVERVIEW].VALUE) {
            dispatch(setMapsOnOverview(newVenueState));
        }
        else {
            dispatch(setVenues(newVenueState));
        }
    };
    useEffect(function () {
        var options = { env: env, user: user, token: token };
        var draftMapObj = getMapData(getCurrentMapOnPage(data), options).draftMapObj;
        updateDraftMaps(draftMapObj);
    }, [pageNumber, mapsPerPage, JSON.stringify(data)]); // data is array so to deep copy will compare data obj correctly
    useEffect(function () {
        var source = venuesListArray !== null && venuesListArray !== void 0 ? venuesListArray : data;
        var currentMapOnThePage = source === null || source === void 0 ? void 0 : source.slice((pageNumber - 1) * mapsPerPage, pageNumber * mapsPerPage);
        setVenueState(currentMapOnThePage);
    }, [venuesListArray, data, mapsPerPage, pageNumber]);
    var showPagination = selectedTab !== HEADER_TABS[HeaderTabKeys.OVERVIEW].VALUE;
    return (_jsx("div", { children: (venueState === null || venueState === void 0 ? void 0 : venueState.length) > 0 ? (_jsxs("div", __assign({ className: "venues", "data-testid": "venues" }, { children: [selectedTab === HEADER_TABS[HeaderTabKeys.OVERVIEW].VALUE
                    ? mapsOnOverview === null || mapsOnOverview === void 0 ? void 0 : mapsOnOverview.map(function (venue, i) {
                        return _jsx(VenueDetailsCard, { venue: venue }, i);
                    })
                    : venueState === null || venueState === void 0 ? void 0 : venueState.map(function (venue, i) {
                        return _jsx(VenueDetailsCard, { venue: venue }, i);
                    }), showPagination && (_jsx(Pagination, { pageInputType: "input", totalItems: data === null || data === void 0 ? void 0 : data.length, itemsPerPage: mapsPerPage, page: pageNumber, onChange: handlePageChange, textAfterItemsPerPage: "{itemsFrom}-{itemsTo} of {totalItems} items", textAfterPage: "of {totalPages}" }))] }))) : (_jsx(Loader, {})) }));
};
export default VenuesList;
